import { FormControl, FormHelperText, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isNullEmpty } from "../../../utils/validation";
import { getOrderFormDeadlineHourOutput } from "../../../http/api/MasterAPI";

const OrderFormDeadlineHourOutputSelect = ({ value, error, onChangeValue }) => {
  const [listOrderFormDeadlineHourOutputSelect, setListOrderFormDeadlineHourOutputSelect] = useState([]);

  async function getOrderFormDeadlineHourOutputSelect() {
    try {
      const response = await getOrderFormDeadlineHourOutput();
      const varList = response.masterVarInfo;
      const result = varList
        .map((element) => ({
          orderFormDeadlineHourOutputCd: element.varCd,
          orderFormDeadlineHourOutputName: element.varValue1,
        }))
        .filter(
          (x) => x.orderFormDeadlineHourOutputName && x.orderFormDeadlineHourOutputName.trim() !== ""
        );
      setListOrderFormDeadlineHourOutputSelect(result);
    } catch (error) {
      console.error("Failed to fetch shop info:", error);
    }
  }

  useEffect(() => {
    getOrderFormDeadlineHourOutputSelect();
  }, []);


  return (
    <FormControl>
      <Select
        value={value}
        onChange={(e) => onChangeValue(e.target.value)}
        sx={{ width: 200 }}
        error={!isNullEmpty(error)}
        //onFocus={() => validate.handleTouch("orderFormDeadlineHourOutputCd")}
      >
        {listOrderFormDeadlineHourOutputSelect.map((item) => (
          <MenuItem
            key={"orderFormDeadlineHourOutput" + item.orderFormDeadlineHourOutputCd}
            value={item.orderFormDeadlineHourOutputCd}
          >
            {item.orderFormDeadlineHourOutputName}
          </MenuItem>
        ))}
      </Select>
      {!isNullEmpty(error) && (
        <FormHelperText sx={{ color: "#d32f2f",marginLeft: 0, width: 200 }}>{error}</FormHelperText>
      )}
    </FormControl>

  );
};

export default OrderFormDeadlineHourOutputSelect;
